import type { Customer } from '@ztechapps/common.contract'
import { Card } from 'react-bootstrap'
import { HorizontalStack, IconValueBlock, Link, ShowIf, Status } from '@ztechapps/webui.util'
import isEmpty from 'lodash/isEmpty'
import { PhoneNumberDisplay } from '../../PhoneNumber/PhoneNumberDisplay'
import type { FunctionComponent } from 'react'
import merge from 'lodash/merge'

const defaultComponents = {
  button: () => null,
}

export type CustomerCardActionButtonProps = {
  by: Customer
}
export type CustomerCardProps = {
  linkTo?: string
  components?: {
    swapButton?: FunctionComponent<CustomerCardActionButtonProps>
    editButton?: FunctionComponent<CustomerCardActionButtonProps>
  }
} & Partial<Customer>

export const UserCard = (props: CustomerCardProps) => {
  return (
    <Card className="border-1 shadow-sm">
      <Card.Body className="p-2">
        <UserCardContent {...props} />
      </Card.Body>
    </Card>
  )
}

export const UserCardContent = (props: CustomerCardProps) => {
  const { profile, status, phone, linkTo } = props
  let { components } = props
  components = merge({}, defaultComponents, components)
  const customerName = profile?.name

  const SwapButton = components?.swapButton
  const EditButton = components?.editButton

  return (
    <>
      <HorizontalStack className={'justify-content-between'}>
        <div className="fw-bold">
          <Status value={status} />
          {isEmpty(linkTo) ? `${customerName}` : <Link href={linkTo}>{customerName}</Link>}
        </div>
        <HorizontalStack gap={1}>
          <SwapButton by={props as Customer} />
          <EditButton by={props as Customer} />
        </HorizontalStack>
      </HorizontalStack>

      <ShowIf condition={!isEmpty(profile?.email)}>
        <div className="small text-nowrap ">
          <IconValueBlock icon="envelope">
            <a href={`mailto:${profile?.email}`}>{profile?.email}</a>
          </IconValueBlock>
        </div>
      </ShowIf>
      <div className="small text-nowrap">
        <IconValueBlock icon="phone">
          <ShowIf condition={!!phone}>
            <a href={`tel:${phone}`}>
              <PhoneNumberDisplay value={phone ?? 'Not Available'} />
            </a>
          </ShowIf>

          <ShowIf condition={!phone}>
            <a href={`tel:`}>Not Available</a>
          </ShowIf>
        </IconValueBlock>
      </div>
    </>
  )
}
